















































































import Vue from "vue";
import { mapActions, mapState } from "vuex";
import { User, getErrorMsg } from "@/types";
import { get, post } from "@/api";

export default Vue.extend({
  props: {
    designer: {
      type: Object,
    },
    project: {
      type: Object,
    },
    ecVisit: {
      type: Object,
    },
    isReAssignDesigner: {
      type: Boolean,
      default: false,
    },
  },
  data(): { [key: string]: any } {
    return {
      designerMetWithClient: {
        showMessage: false,
        didMeet: false,
      },
    };
  },
  computed: {
    ...mapState("appModule", {
      projects: "projects",
      selectedEc: "selectedEc",
      partialProject: "partialProject",
    }),
  },
  methods: {
    ...mapActions("appModule", ["getFormStructureSchema"]),
    ...mapActions("appModule", [
      "createLead",
      "getProjects",
      "notifyUsers",
      "updateEcVisit",
      "getEcInfoOfUser",
    ]),
    reAssignDesigner() {
      (this as any).$emit("reassign");
    },
    designerMetClient(completed: boolean) {
      //notify the user
      //poll for user response
      const ctx = this;
      if (ctx.partialProject.ec_visit && ctx.partialProject.ec_visit.id) {
        (this as any)
          .handleWithDecorationAction(() => {
            return ctx.updateEcVisit({
              visit_id: ctx.partialProject.ec_visit.id,
              data: {
                completed: completed,
              },
            });
          })
          .then((response: any) => {
            (this as any).$store.dispatch("uiModule/addToast", {
              severity: "success",
              message: "EC Visit updated",
            });
            (this as any).designerMetWithClient = {
              showMessage: true,
              didMeet: completed,
            };
          })
          .catch((err: any) => {
            (this as any).$store.commit(
              "appModule/updateUserNotificationState",
              "failed"
            );
          });
      }
    },
    handleWithDecorationAction(asyncFunc: (...args: any) => Promise<any>) {
      return asyncFunc
        .apply(arguments)
        .then((response: any) => {
          return response;
        })
        .catch((err: any) => {
          (this as any).$store.commit("uiModule/hideLoadingModal", null, {
            root: true,
          });
          (this as any).$store.dispatch("uiModule/addToast", {
            severity: "error",
            message: getErrorMsg(err),
          });
          throw err;
        });
    },
  },
});
